import { Injectable, signal, WritableSignal } from '@angular/core';
import { System2d } from '../asset/asset.dto';
import { ObservableService } from '@damofire/data-angular-commons';
import { cloneDeep } from 'lodash-es';

export function generateAndAssignSystemIds(system2ds: System2d[]): System2d[] {
  const timestamp: number = Date.now();
  return system2ds.map((system, index) =>
    system._id
      ? system
      : {
          ...cloneDeep(system),
          _id: `${timestamp + index}`,
        },
  );
}

@Injectable()
export abstract class SystemDrawingService extends ObservableService<System2d> {
  protected systems: WritableSignal<System2d[]> = signal([]);
  protected divisionId: WritableSignal<string> = signal('');
  protected section: WritableSignal<string | null> = signal(null);

  constructor() {
    super();
  }

  abstract reloadSystems(): Promise<void>;
  abstract get(division: string, system: string): Promise<System2d>;

  abstract create(divisionId: string, systems: System2d[]): Promise<void>;
  abstract delete(divisionId: string, systems: System2d[]): Promise<void>;
  abstract update(divisionId: string, systems: System2d[]): Promise<void>;

  async list(division: string, section: string | null = null): Promise<System2d[]> {
    if (division !== this.divisionId() || section !== this.section()) {
      this.divisionId.set(division);
      this.section.set(section);

      await this.reloadSystems();
    }

    return this.systems();
  }
}
